<template lang="html">
    <div class="login-index">
        <div class="fd-banner">
            <h3></h3>
            <div class="fd-title">
                <div class="fd-title-inner">
                    <div class="title-content">
                        <h3>Hi, 您好</h3>
                        <div>
                            欢迎登录在线服务保全系统
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="login-content">
            登录页面
            <van-cell-group>
                <div id="login-field-title">登录</div>
                <h4 class="fd-login-tit">账号</h4>
                <van-field v-model="loginName" placeholder="请输入账号"></van-field>
                <h4 class="fd-login-tit">密码</h4>
                <van-field type="password" v-model="password" placeholder="请输入密码"></van-field>
<!--                <h4 class="fd-login-tit">验证码</h4>-->
<!--                <van-row>-->
<!--                    <van-col span="18">-->
<!--                        <van-field id="verify-input" v-model="verifyCode" placeholder="请输入验证码" maxlength="6"></van-field>-->
<!--                    </van-col>-->
<!--                    <van-col span="6">-->
<!--                        <div class="fd-verification-code">-->
<!--                            <div class="fd-Verification">-->
<!--                                <span v-for="(item, index) in codeOBJ.codeList" :key="index" :style="getStyle(item)">{{item.code}}</span>-->
<!--                                <div class="fd-model"></div>-->
<!--                            </div>-->
<!--                            <van-icon class="fd-refresh-icon" name="replay" @click="refreshVerifyCode()"></van-icon>-->
<!--                        </div>-->
<!--                    </van-col>-->
<!--                </van-row>-->
                <!-- <div id="get-password-back">
                    找回您的密码
                </div> -->
                <div class="fd-login-btn">
                    <van-button
                            id="login-button"
                            type="info"
                            @click="loginAndGoHome"
                            size="large"
                            round
                    >
                        立即登录
                    </van-button>
                </div>
            </van-cell-group>
            <!-- <div id="register-class">
                还没有账号? 点击
                <router-link class="fd-register-btn" to="/register">立即注册</router-link>
            </div> -->
        </div>
    </div>
</template>

<script>
    import {setToken} from '@/utils/auth';
    import newCode from '@/utils/Verification.js';
    import validate from '@/utils/validator/validator';
    import {
        NotNull
    } from '@/utils/validator/commonRules';
    import config from '../../api/config.js'

    export default {
        data() {
            return {
                loginName: '',
                password: '',
                // verifyCode: '',
                realVerifyCode: '',
                codeOBJ: '',
                config
            }
        },
        methods: {
            // getVerifyCode: function () {
            //     return this.$axios.get('account/api/account/verificode')
            //         .then(res => {
            //             let verifyCode = res.data;
            //             this.realVerifyCode = verifyCode;
            //         });
            // },
            //         then(() => {
            //     if (!this.verifyCode) {
            //         throw '请输入验证码';
            //     } else if (this.verifyCode.toLowerCase() !== this.codeOBJ.code.toLowerCase()) {
            //         throw '验证码不正确';
            //     }
            // })
            loginAndGoHome: function () {
                const validated = this.validateFormData();
                validated.then(() => {
                    //TODO
                    this.$axios.post('account/api/account/login?ly=2&username=' + this.loginName + '&password=' + this.password)
                    // this.$axios.post('account/api/account/testLogin?username=' + this.loginName + '&password=' + this.password)
                        .then(res => {
                            if (res.code == 200) {
                                setToken(res.data);
                                this.$notify({type: 'success', message: res.message});
                            } else {
                                this.$notify(res.message);
                                throw res.message;
                            }
                        })
                        .then(() => {
                            this.$router.push('/');
                        });
                }).catch(error => {
                    this.$notify(error);
                });
            },
            getStyle(data) {
                return `color: ${data.color}; font-size: ${data.fontSize};transform: ${data.transform};float:left;display:block;`
            },
            // refreshVerifyCode: function () {
            //     this.getVerifyCode().then(() => {
            //         this.codeOBJ = new newCode(6, this.realVerifyCode);
            //     });
            // },
            validateFormData: function () {
                let descriptor = {
                    'loginName': new NotNull('string', '请输入登录名'),
                    'password': new NotNull('string', '请输密码'),
                    // 'verifyCode': new NotNull('string', '请输入验证码'),
                };
                const validated = validate(descriptor, {
                    'loginName': this.loginName,
                    'password': this.password,
                    // 'verifyCode': this.verifyCode
                });
                return validated;
            },
            clearUselessKey: function () {
                // 访问登录页面清除token, 防止请求不需要权限的接口报错
                setToken(null);
                // 清除当前担保id
                sessionStorage.removeItem("currentDbid");
                // 清除当前保全id
                sessionStorage.removeItem("currentBqid");
            }
        },
        created() {
            this.clearUselessKey();
            // this.refreshVerifyCode();
        }
    }
</script>

<style lang="less" scoped>
    .login-index {
        overflow-y: scroll;
        width: 100%;
        height: 100%;
        background: #f3f3f3;

        .fd-banner {
            width: 100%;
            height: 51%;
            background: url('../../assets/image/icon-head.png') no-repeat center center;
            position: absolute;

            > h3 {
                font-size: 18px;
                color: #fff;
                text-align: left;
                padding-top: 30px/2;
            }

            .fd-title {
                padding-top: 40px;
                padding-bottom: 76px/2;
                color: #fff;

                .fd-title-inner {
                    width: 94%;
                    margin-left: 10%;
                    display: flex;

                    .title-logo {
                        width: 90px/2;
                        height: 104px/2;
                        margin-top: 6px;
                    }
                }
            }
        }

        .login-content {
            padding-top: 220px/2;
            width: 90%;
            margin-left: 5%;
        }

        #login-field-title {
            width: 90%;
            margin-left: 5%;
            color: #0683fc;
            padding: 20px 0;
            font-size: 24px;
        }

        .field-title {
            width: 90%;
            color: #666666;
            font-family: "Microsoft YaHei";
        }

        .title-content {
            text-align: left;

            > h3 {
                font-size: 22px;
            }

            > div {
                font-size: 24px;
                margin-top: 8px;
                letter-spacing: 2px;
            }
        }

        #get-password-back {
            width: 90%;
            color: #666666;
            font-family: "Microsoft YaHei";
            text-align: right;
        }

        #login-button {
            margin-top: 15px;
        }

        #register-class {
            width: 90%;
            color: #666666;
            font-family: "Microsoft YaHei";
            text-align: center;
            margin-top: 20px;
        }

        .fd-login-tit {
            color: #999999;
            margin-top: 10px;
            margin-left: 18px;
        }

        .fd-login-btn {
            width: 90%;
            margin-left: 5%;
        }

        .fd-register-btn {
            color: #0683fc;
        }

        .fd-refresh-icon {
            color: #0683fc;
            font-size: 26px;
            padding-left: 5px;
        }

        .fd-verification-code {
            display: flex;
        }
    }
</style>
